export default __webpack_public_path__ + "static/media/logo-cny-dragon.80919454.png";